import * as React from 'react';

var _circle, _path, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgX = function SvgX(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 44,
        cy: 44,
        r: 30,
        fill: "url(#paint0_linear_19_400)",
        fillOpacity: 0.16
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_19_400)",
        d: "M40 41.833 51.327 53.16q.365.365.885.398.519.032.948-.398.43-.43.43-.916t-.43-.917L41.833 40 53.16 28.673q.365-.365.398-.884.032-.52-.398-.95t-.916-.429-.917.43L40 38.167 28.673 26.84a1.33 1.33 0 0 0-.884-.398q-.52-.032-.95.398t-.429.916.43.917L38.167 40 26.84 51.327a1.33 1.33 0 0 0-.398.885q-.032.519.398.948.43.43.916.43t.917-.43zM40.011 70q-6.203 0-11.65-2.362-5.445-2.361-9.54-6.451-4.093-4.09-6.457-9.531T10 40.01q0-6.223 2.362-11.7 2.361-5.48 6.451-9.531 4.09-4.053 9.532-6.416Q33.785 10 39.989 10q6.223 0 11.7 2.362 5.48 2.36 9.531 6.41 4.053 4.049 6.416 9.521T70 39.99q0 6.204-2.362 11.65-2.36 5.445-6.41 9.54-4.049 4.093-9.521 6.457T40.01 70M40 67.436q11.449 0 19.442-8.003T67.436 40q0-11.448-7.994-19.442T40 12.564q-11.43 0-19.433 7.994T12.564 40q0 11.43 8.003 19.433T40 67.436"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_19_400",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_19_400",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgX as ReactComponent };
//# sourceMappingURL=X.svg.es.js.map
